// extracted by mini-css-extract-plugin
export default {"posts":"Experiences_posts__m-OkY"};